import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'
import { subscriptionsRouteNames } from '@/routes/constants/location'

const Subscriptions = () => import('@/pmd/pages/payments/v2/Subscriptions.vue')
const SubscriptionDetails = () => import('@/pmd/pages/payments/v2/SubscriptionDetails.vue')

export const SubscriptionsRoute: RouteConfig[] = [
  {
    path: 'payments/v2/subscriptions',
    name: subscriptionsRouteNames.subscriptions,
    component: Subscriptions,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/v2/subscriptions/:id',
    name: subscriptionsRouteNames.subscriptionDetails,
    component: SubscriptionDetails,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
]
